import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  radioAnatomy.keys
);

const baseStyle = definePartsStyle({
  control: {
    w: 8,
    h: 8,
    borderColor: 'grey',
    backgroundColor: 'white',
    _checked: { bg: 'blue.500', borderColor: 'blue.500' },
    _hover: { borderColor: 'gray.400' }
  },
  label: {
    fontSize: 'md'
  },
  container: {
    display: 'flex',
    alignItems: 'top'
  }
});

const sizes = {
  wide: definePartsStyle({
    container: { marginBottom: 2 }
  })
};

export const radioTheme = defineMultiStyleConfig({ baseStyle, sizes });
